import { z } from 'zod';
// Shared by design: now-playing and listening-history rows are the same shape, so one schema rather than two that could drift.
// Lengths aren't arbitrary — apps/api/src/db/schema.ts sizes the `listens` columns from these constants.
export const TRACK_ID_MAX_LENGTH = 64;
export const TRACK_NAME_MAX_LENGTH = 256;
export const ALBUM_NAME_MAX_LENGTH = 256;
export const ARTIST_NAME_MAX_LENGTH = 256;
export const IMAGE_URL_MAX_LENGTH = 512;
/** Broken out so the API can validate the JSON array it stores per listen. */
export const ArtistNamesSchema = z.array(z.string().min(1).max(ARTIST_NAME_MAX_LENGTH)).min(1);
export const TrackSchema = z
    .strictObject({
    id: z.string().min(1).max(TRACK_ID_MAX_LENGTH),
    name: z.string().min(1).max(TRACK_NAME_MAX_LENGTH),
    artists: ArtistNamesSchema,
    albumName: z.string().min(1).max(ALBUM_NAME_MAX_LENGTH),
    albumImageUrl: z.url().max(IMAGE_URL_MAX_LENGTH).nullable(),
    durationMs: z.number().int().positive(),
})
    .readonly();
//# sourceMappingURL=track.js.map